import React from 'react';

import Viewport from './Viewport';
import Console from './Console';
import Header from './Header';
import RightPanel from './RightPanel';
import { Sidebar } from './Sidebar';
import { Outlet } from 'react-router-dom';

const MainLayout: React.FC = () => {
    return (
        <div className="flex h-screen w-full bg-black text-zinc-100 overflow-hidden font-sans">
            {/* Left Sidebar */}
            <Sidebar />

            {/* Center Content (Viewport + Console) */}
            <div className="flex-1 flex flex-col min-w-0 bg-stone-950">
                <Header />
                <div className="flex-1 relative flex flex-col min-h-0">
                    <Viewport />

                    <div className="absolute inset-0 pointer-events-none">
                        <Outlet />
                    </div>
                </div>
                <Console />
            </div>

            {/* Right Panel (Merged Properties + Assets + Navigation) */}
            <RightPanel />
        </div>
    );
};

export default MainLayout;
